import React from 'react';

import Help from '../help';
import Copy from '../../components/copy';

import './box.css';

export const Box = props => {
	const {
		id,
		image,
		fa,
		className,
		title,
		logo,
		help,
		button,
		preButton,
		postButton,
		buttonAlign,
		children,
		footer,
		tabs,
		tabNames,
		tab,
		setTab,
		hideEllipsis,
	} = props;

	return (
		<div data-testid={id ? `box-${id}` : undefined} className={`box ${className}`}>
			{tabs && (
				<div className="box-tabs">
					{tabs.map(t => (
						<span key={`tab-${t}`} className={tab === t ? 'selected' : ''} onClick={() => setTab(t)}>
							{typeof tabNames === 'function' ? tabNames(t) : tabNames[t]}
						</span>
					))}
				</div>
			)}
			{title && (
				<div className="box-header with-border flex flex-center">
					{preButton && <span className="ml10">{preButton()}</span>}
					<div className={`flex-grow mr5${hideEllipsis ? '' : ' ellipsis'}`}>
						<span className="flex flex-center">
							{image && <img src={image} alt="" height="20" className="mr10" />}
							{logo && <img src={logo} alt="" />}
							{fa && <i className={`mr5 fa ${fa}`} />}
							<span className={hideEllipsis ? '' : 'ellipsis'}>{title}</span>
							{postButton && <span className="ml10">{postButton()}</span>}
							{help && (
								<Help id={`box-header-${id}`}>
									<Copy value={help} />
								</Help>
							)}
						</span>
					</div>
					{button && <span className="pull-right">{button()}</span>}
				</div>
			)}
			<div className="box-body">{children}</div>
			{footer && <div className="box-footer">{footer}</div>}
		</div>
	);
};

export default Box;
